<template>
  <button :disabled="disabled" type="button" class="h-button" :class="buttonClasses" @click="$emit('click', $event)">
    <div v-if="icon !== undefined" class="h-button__icon">
      <svg-icon {...icon}></svg-icon>
    </div>

    <span class="h-button__label">
      {{ label }}
      <slot></slot>
    </span>
  </button>
</template>

<script>
export default {
  name: "h-button",

  props: ["label", "size", "icon", "color", "inverse", "mode", "disabled"],

  data() {
    return {};
  },

  computed: {
    buttonClasses() {
      const classes = [];
      if (this.mode === "text") {
        classes.push("h-button--text");
      }
      if (this.size === "lg") {
        classes.push("h-button--lg");
      }
      return classes.join(" ");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.h-button {
  cursor: pointer;
  background: none;
  border: 1px solid $color-button-border;
  height: 30px;
  border-radius: 15px;
  padding: 0 15px;
  color: #000;
  white-space: nowrap;
  transition: 0.2s;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  box-sizing: border-box;
  flex-shrink: 0;
  position: relative;

  &:focus {
    outline: none;
  }

  &:hover {
    border-color: $color-button-border-hover;
  }

  &--lg {
    height: 38px;
    border-radius: 19px;
    font-size: 15px;
    padding: 0 30px;
  }

  &--text {
    padding: 0;
    height: auto;
    background: transparent;
    border: none;
  }

  &[disabled] {
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
  }
}
</style>
